var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2363_519)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2363_519",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12V12H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2363_519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39995 3.00002C5.39995 2.66866 5.13133 2.40002 4.79995 2.40002C4.46858 2.40002 4.19995 2.66866 4.19995 3.00002V4.80002C4.19995 4.95916 4.26317 5.11177 4.37569 5.22429L5.57569 6.42428C5.81 6.65858 6.18991 6.65858 6.42421 6.42428C6.65851 6.18998 6.65851 5.81008 6.42421 5.57576L5.39995 4.5515V3.00002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5872 7.7382L11.8242 10.9758C11.8799 11.0315 11.9242 11.0976 11.9544 11.1704C11.9846 11.2432 12.0001 11.3212 12.0001 11.4C12.0001 11.4788 11.9846 11.5568 11.9544 11.6296C11.9242 11.7024 11.8799 11.7685 11.8242 11.8242C11.7686 11.8801 11.7025 11.9245 11.6297 11.9548C11.5569 11.9851 11.4788 12.0006 11.4 12.0006C11.3212 12.0006 11.2431 11.9851 11.1703 11.9548C11.0975 11.9245 11.0314 11.8801 10.9758 11.8242L7.7382 8.5872C6.89922 9.24318 5.86497 9.5997 4.8 9.6C2.1534 9.6 0 7.4466 0 4.8C0 2.1534 2.1534 0 4.8 0C7.4466 0 9.6 2.1534 9.6 4.8C9.60006 5.86503 9.24348 6.8994 8.5872 7.7382ZM4.8 1.2C2.8146 1.2 1.2 2.8146 1.2 4.8C1.2 6.7854 2.8146 8.4 4.8 8.4C6.7854 8.4 8.4 6.7854 8.4 4.8C8.4 2.8146 6.7854 1.2 4.8 1.2Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2363_519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.71a16e7b94e183c02f7b29ff61682463.svg";
export { ForwardRef as ReactComponent };